import { _, Radio } from "../../vendor";
import Biscuit from "./Biscuit";
// @ts-ignore
import { appErrorTpl, appAccessErrorTpl } from "../views/AppAnnouncements";

/**
 * @method utils.Dependencies
 * @author Felix Albroscheit
 *
 * Kinda behavior that keeps track on all required
 * InboomaBaseAsyncCollections for rendering a view
 *
 * @param { array } dependencies
 * @return Promise
 *
 * Available options for each dependency:
 * 'orders' : {
 *       'class' : new (InboomaBaseAsyncCollection)(),
 *       'notForUserRole' : (string) // name of user.role
 *   },
 */

export default function (dependencies: any): Promise<unknown> {
  return new Promise(
    (
      resolve: (value: PromiseLike<unknown> | unknown) => void,
      reject: (reason?: any) => void,
    ): void => {
      let loadedDependencies: number = 0,
        requestsWithError: number = 0,
        dependenciesLength: number = _.size(dependencies);

      const app: Radio.Channel = Radio.channel("app"),
        _resolve: () => void = function (): void {
          if (++loadedDependencies === dependenciesLength) {
            app.trigger("collection:loaded");
            // @ts-ignore
            resolve();
          }
        };

      _.each(dependencies, (collection: any, collectionName: any): void => {
        if (typeof collection["class"] != "undefined") {
          // @todo replace with actual role-dependent
          // load function

          const userRole = Biscuit.get("user.role");

          if (
            typeof collection["notForUserRole"] !== "undefined" &&
            collection["notForUserRole"] == userRole
          ) {
            dependenciesLength--;
            return;
          }

          collection = collection["class"];
        }

        // @ts-ignore
        const alreadyFetching = typeof Radio._channels[collectionName] !== "undefined",
          channel = Radio.channel(collectionName),
          collectionData = channel.request("get:data");

        if (!collectionData && alreadyFetching) {
          channel.on("collection:ready", () => {
            _resolve();
          });

          return;
        }

        if (!collectionData && !alreadyFetching) {
          collection
            .fetch({ add: false, merge: false, remove: false })
            .then((data: any): void => {
              // Passed negative mergeParameters to avoid
              // native call on Backbone.Collection.set(response)

              collection._setCollectionData(data.response);

              collection.trigger("after:fetch:success", data.response);

              channel.reply("get:data", () => collection);

              channel.trigger("collection:ready");

              _resolve();
            })
            .catch((data: any): void => {
              // Fetch errors in multiple ways as API
              // has several ways to indicate missing
              // or outdated token's...

              collection.trigger("collection:error", collectionName, data);
              console.log("error in", collectionName, data);

              if (typeof data.response !== "undefined") {
                if (typeof data.response.responseJSON !== "undefined") {
                  data = data.response.responseJSON.data;

                  if (data.code === 401) {
                    requestsWithError++;
                  }
                } else if (typeof data.statusText !== "undefined") {
                  if (data.statusText === "error") {
                    requestsWithError++;
                  }
                }
              }

              if (requestsWithError === dependenciesLength) {
                // Invalid or out-dated token -> logout!
                app.trigger("destroy:session", true);
              }

              app.trigger("collection:loaded");

              let errorMessageDiv = appErrorTpl;

              if (typeof data.response != "undefined") {
                if (data.response.statusText == "Forbidden") {
                  errorMessageDiv = appAccessErrorTpl;
                }
              }

              app.trigger("show:announcement", errorMessageDiv);

              reject(data);
            });
        } else {
          _resolve();
        }
      });
    },
  );
}
